// src/types/ambassador.types.ts
export interface AmbassadorApplicationData {
  fullName: string;
  email: string;
  whatsappNumber: string;
  country: string;
  city: string;
  ageRange: string;

  instagramHandle: string;
  tiktokHandle: string;
  strongestPlatform: "instagram" | "tiktok" | "both";
  followerRange: string;
  contentNiche: string;
  audienceSummary: string;
  bestContentLink1: string;
  bestContentLink2: string;

  whyJoin: string;
  howWouldYouShareLrnsy: string;
  availableForZoom: boolean;
  comfortableWithKpis: boolean;
  preferredPayoutMethod: string;
}

export interface EarningsExample {
  purchases: number;
  earnings: number;
}

export const EARNINGS_EXAMPLES: EarningsExample[] = [
  { purchases: 10, earnings: 400 },
  { purchases: 20, earnings: 800 },
  { purchases: 50, earnings: 2000 },
  { purchases: 100, earnings: 4000 },
];
